import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { isReactSelectSingleOption } from "components/ProjectSpecificComponents/Interfaces/ExternalComponentsInterfaces"
import { observer } from "mobx-react-lite"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import MainFieldSelect from "../../atoms/MainFieldSelect"
import FormField from "../FormField"
import ToolFieldPropertiesHeaderWithContent from "../ToolFieldPropertiesHeaderWithContent"
import getFieldDataByMainFieldKey from "./NewRequestForm/Functions/getFieldDataByMainFieldKey"

interface Props {}

const SavedRequestForm = observer(({}: Props) => {
	const formStore = useFormStore()
	const { t } = useTranslation()
	const { isMobile } = useScreenType()

	const [isSectionHidden] = useState<{ [k: string]: boolean }>({})
	const [refreshCount, refresh] = useState(0)

	const toggleIsSectionHidden = (fieldKey: string) => {
		isSectionHidden[fieldKey] = !!!isSectionHidden[fieldKey]
		refresh((count) => count + 1)
	}
	const getFieldType = (mainFieldKey: string) => {
		return getFieldDataByMainFieldKey(mainFieldKey, formStore.mainFieldsData ?? [])?.fieldType
	}

	return (
		<HyperDiv direction="column" spaceBetweenElems="2rem">
			{formStore.selectedFormsConfig?.savedRequestForm.map((data, i) => {
				const { nameLV, nameEN, mainFieldLabel, mainFieldKey } = data
				// ! TECHNICAL DEBT: 3184, replace this with dynamic key ([parsedkey])
				let isEN = formStore.savedRequestLanguage === "en"
				const handleLanguageSelect = (nameText: string | undefined) => {
					if (isEN) {
						formStore.mergeSavedRequestFormData(i, { nameEN: nameText })
					} else {
						formStore.mergeSavedRequestFormData(i, { nameLV: nameText })
					}
				}
				return (
					<ToolFieldPropertiesHeaderWithContent
						key={i + mainFieldKey}
						label={mainFieldLabel}
						selectedLanguage={formStore.savedRequestLanguage}
						titleInputValue={isEN ? nameEN : nameLV}
						buttonColors={formStore.settingsData.personalize}
						tooltipInputHidden
						titleInputPlaceholder={t("rawText.fieldName")}
						isContentHidden={isSectionHidden[mainFieldKey]}
						onClickMoveUp={() => formStore.moveFieldInForm("savedRequestForm", i, i - 1)}
						onClickMoveDown={() => formStore.moveFieldInForm("savedRequestForm", i, i + 1)}
						onClickRemove={() => formStore.deleteFormField("savedRequestForm", i)}
						onClickLabel={() => toggleIsSectionHidden(mainFieldKey)}
						onChangeFormData={({ nameText }) => {
							handleLanguageSelect(nameText)
						}}
					>
						<HyperDiv width={isMobile ? undefined : 250}>
							<Whitespace x="0.3" />
							<FormField
								direction={isMobile ? "Horizontal" : "Vertical"}
								label={t(`forms.field-label.field`)}
								placeholderValue=""
								editable
							>
								<MainFieldSelect
									valueKey={mainFieldKey}
									onChange={(selectedOption) => {
										formStore.mergeSavedRequestFormData(
											i,
											isReactSelectSingleOption(selectedOption)
												? {
														mainFieldKey: selectedOption.value,
														mainFieldLabel: selectedOption.label,
														fieldType: getFieldType(selectedOption.value),
												  }
												: { mainFieldKey: undefined, mainFieldLabel: undefined }
										)
									}}
									type={"savedRequestForm"}
								/>
							</FormField>
							<Whitespace x="2" />
						</HyperDiv>
					</ToolFieldPropertiesHeaderWithContent>
				)
			})}
		</HyperDiv>
	)
})

export default SavedRequestForm
